<template>
  <div class="pg-page">

    <!-- Hero -->
    <div class="pg-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-school-outline</v-icon>
        </v-avatar>
        <div>
          <div class="pg-hero__title">
            {{ menu_name }} <span style="opacity:.7;">{{ estado ? 'Activos' : 'Eliminados' }}</span>
          </div>
          <div class="pg-hero__sub">
            <v-icon x-small color="rgba(255,255,255,0.6)" class="mr-1">mdi-map-marker-outline</v-icon>
            {{ $store.state.CARGO.sede.nombre }}
          </div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;">
        <router-link
          v-if="permiso_add && !$store.state.isonlyread && $store.state.createPostgrado"
          to="postgradoadd" style="text-decoration:none;">
          <v-btn small dark depressed color="rgba(255,255,255,0.18)">
            <v-icon left small>mdi-plus</v-icon> Crear {{ menu_name }}
          </v-btn>
        </router-link>
        <v-btn small dark text v-if="!estado" @click="setEstado(true)">
          <v-icon left small>mdi-eye-outline</v-icon> Ver Activos
        </v-btn>
        <v-btn small dark text v-if="estado" @click="setEstado(false)">
          <v-icon left small>mdi-eye-off-outline</v-icon> Ver Eliminados
        </v-btn>
      </div>
    </div>

    <div class="pg-body">

      <!-- Nota deprecación -->
      <v-alert v-if="notita" type="warning" dense outlined class="mb-4" style="font-size:0.83rem;">
        <strong>NOTA:</strong> Esta funcionalidad será reemplazada con la lista de programas aprobados en la oferta académica.
      </v-alert>

      <!-- Toolbar -->
      <v-card outlined class="pg-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex flex-wrap align-center" style="gap:10px;">
          <v-text-field
            v-model="nombre"
            :placeholder="'Buscar ' + menu_name + ' por nombre...'"
            prepend-inner-icon="mdi-magnify"
            dense outlined hide-details clearable
            style="max-width:340px;"
            @keyup.enter="get_postgrados()"
          />
          <v-btn small depressed color="indigo darken-1" dark :loading="loading" @click="get_postgrados()">
            {{ txt_btn_listar }}
          </v-btn>
          <v-chip x-small :color="items.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ items.length }} registro{{ items.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <!-- Leyenda de estados -->
          <div class="d-flex align-center" style="gap:8px; font-size:0.75rem; color:#546e7a;">
            <span><v-icon x-small color="red">mdi-circle</v-icon> Por aprobar</span>
            <span><v-icon x-small color="orange">mdi-circle</v-icon> Aprobado</span>
            <span><v-icon x-small color="green">mdi-circle</v-icon> Se pueden crear programas</span>
          </div>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="pg-table-card">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          :items-per-page="20"
          :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
          loader-height="3"
          loading-text="Cargando..."
          no-data-text="Sin registros."
          dense
          class="pg-table"
        >
          <!-- Estado (círculo de color) -->
          <template v-slot:[`item.status`]="{ item }">
            <v-icon small :color="statusColor(item.status)">mdi-circle</v-icon>
          </template>

          <!-- Netsuite -->
          <template v-slot:[`item.clasenetsuite`]="{ item }">
            <span>{{ item.clasenetsuite ? item.clasenetsuite.nombre : '' }}</span>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex" style="gap:2px;">

              <v-tooltip bottom v-if="!$store.state.isonlyread && $store.state.updatePostgrado && estado">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="indigo darken-1" v-on="on"
                    :disabled="item.status < 2" @click="showAddProgramarestv2(item)">
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Crear nuevo Programa</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!$store.state.isonlyread && $store.state.updatePostgrado && estado">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="grey darken-1" v-on="on" @click="showModPostgrado(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar {{ menu_name }}</span>
              </v-tooltip>

              <v-tooltip bottom v-if="$store.state.cambiarPostgradoStatus && estado">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="teal darken-1" v-on="on" @click="verProgramas(item)">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver Programas creados</span>
              </v-tooltip>

              <v-tooltip bottom v-if="(!$store.state.isonlyread && estado) || isdirectorcca">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="orange darken-2" v-on="on"
                    :disabled="!permitido && !isdirectorcca"
                    @click="cambiarPostgradoStatus(item)">
                    <v-icon>mdi-check-decagram-outline</v-icon>
                  </v-btn>
                </template>
                <span>Aprobar {{ menu_name }}</span>
              </v-tooltip>

            </div>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <modal ref="modalEstado" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    <notifications group="auth" position="bottom right" />
    <post-programas ref="refPostProgramas" />
    <AaprobarPostgrado ref="refAaprobarPostgrado" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import modal from '@/components/AEstado.vue';
import { parseUnidadDuracion2, parseColorcito } from '@/components/Utils.js';
import PostProgramas from './PostProgramas';
import AaprobarPostgrado from '../../components/AaprobarPostgrado.vue';
import { mapState } from 'vuex';

export default {
  components: { modal, PostProgramas, AaprobarPostgrado },
  data() {
    return {
      txt_btn_listar: 'Ver Más',
      msg: '0 ' + process.env.VUE_APP_NAME_MENU,
      seleccionadof: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, prog: {} },
      seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
      tamanio: 0,
      cursor: 10000000,
      estado: true,
      showbtnaprobar: true,
      nombre: '',
      search: '',
      postgrados: [],
      timeoutHnd: 0,
      permitido: false,
      loading: false,
      menu_name: process.env.VUE_APP_NAME_MENU,
      isdirectorcca: false,
      permiso_add: true,
      notita: false,
      items: [],
      headers: [
        { text: '#',            value: 'index',              width: 60,  sortable: false },
        { text: 'Nombre',       value: 'nombre' },
        { text: 'Categoría',    value: 'categoria.nombre',   width: 140 },
        { text: 'Área',         value: 'area.nombre',        width: 130 },
        { text: 'Netsuite',     value: 'clasenetsuite',      width: 130 },
        { text: 'Duración',     value: 'duracion_text',      width: 110 },
        { text: 'Carga Hor.',   value: 'carga_horaria_text', width: 100 },
        { text: 'Creditaje',    value: 'creditaje_text',     width: 100 },
        { text: 'Estado',       value: 'status',             width: 70  },
        { text: 'Opciones',     value: 'actions',            width: 160, sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.get_postgrados();
      this.verificarPermiso();
    },
    nombre: function(a) {
      if (a != null && a.length > 3) this.txt_btn_listar = 'Buscar por nombre';
      else this.txt_btn_listar = 'Ver Más';
      if (this.timeoutHnd) { clearTimeout(this.timeoutHnd); this.timeoutHnd = 0; }
      const vue = this;
      this.timeoutHnd = setTimeout(function() {
        if (vue.nombre.length > 3) { vue.cursor = 10000000; vue.get_postgrados(); }
        vue.timeoutHnd = 0;
      }, 500);
    },
  },
  methods: {
    statusColor(status) {
      const cls = parseColorcito(status);
      if (cls === 'rojito')  return 'red';
      if (cls === 'naranja') return 'orange';
      if (cls === 'verde')   return 'green';
      if (cls === 'marron')  return 'brown';
      return 'grey';
    },
    showAddProgramarestv2(item) { 
      const u = this.$store.state.CARGO.sede.unidad_negocio 
      const cargo = this.$store.state.CARGO.id
      let usuarioid = this.$store.state.DATA_USER.id;
        // 65958 = caludia 
        // 30820 = fanny 
        // 44958 = anahi 
        // 60531 = gilmer
        // 160967 = amelier 
        // 76447 = clarice 
      const permitidos = [65958,30820,44958,60531,160967,76447,43];
      if(u == 10 && !permitidos.includes(usuarioid)){
        this.$root.$notify.show('Categoria no disponible :)', { color: 'red', x: 'right' });
        return
      }

      
      /* if((item.categoria.id != 57 && item.categoria.id != 28) && u == 10){
        this.$root.$notify.show('Categoria no disponible :)', { color: 'red', x: 'right' });
        return
      } */
      // cate 1,2,3 son posgrados; 4,5... son cursos
      const uid = this.$store.state.DATA_USER.id;
      /* 
      ID = 93	7169386-U	Amelia	Guzman
      ID = 22161	8540733	Cintia Beatriz	Oropeza
      ID = 47129	10661632	Elio Diego	Castillo
      ID = 59716	7136859	Valeria Del Rosario	Vaca
      ID = 65958 claudia escobar
      ID = 30820 Fanny ortiz 
      ID = 44958 Anahí Daniela Vega Rojas
      */

      const esPosgrado = [1, 2, 3].includes(item.categoria.id);
      const usuariosPosgrado = [93, 22161, 47129, 59716, 65958, 30820, 44958, 160967];
      const rol = [1]

      if ((u === 1 || u == 5) && esPosgrado && !usuariosPosgrado.includes(uid) && !rol.includes(cargo)) {
        this.$root.$notify.show('Categoría no disponible o usuario no autorizado para crear', {
          color: 'red',
          x: 'right'
        });
        return;
      }
      
      this.$store.dispatch('postgrado/selectPostgrado', item);
      window.sessionStorage.setItem('xpostgradorest', JSON.stringify(item));
      this.$router.push({ name: 'programaviewrest' });
    },
    showModPostgrado(item) {
      const u = this.$store.state.CARGO.sede.unidad_negocio 
      if((item.categoria.id != 57 && item.categoria.id != 28) && u == 10){
        this.$root.$notify.show('Categoria no disponible', { color: 'red', x: 'right' });
        return
      }
      this.$store.dispatch('postgrado/selectPostgrado', item);
      window.sessionStorage.setItem('xpostgrado', JSON.stringify(item));
      this.$router.push({ name: 'postgradomod' });
    },
    verProgramas(item) {
      this.$store.dispatch('postgrado/selectPostgrado', item);
      this.$refs.refPostProgramas.showThisView(item);
    },
    load_data() { this.get_postgrados(); },
    dialogo(tit, txt) {
      this.$dialog.confirm('<b>' + tit + '</b><br><br>' + txt)
        .then(function() {}).catch(function(e) { window.console.error(e); });
    },
    async get_postgrados() {
      this.items = [];
      this.loading = true;
      const vue = this;
      const unidad = this.$store.state.CARGO.sede.unidad_negocio;
      const qs = gql`query{ getPostgrados( cursor:${this.cursor}, estado:${this.estado}, unidad_negocio_id:${unidad}
        ${this.nombre ? ',nombre:"' + this.nombre.trim() + '"' : ''})
        {id,nombre,duracion,creditaje,unidad_negocio_id,status,carga_horaria,unidad_duracion,estado,objetivo,dirigido,categoria{id,nombre,clase_netsuite_id},area{id,nombre},clasenetsuite{id nombre}}}`;
      let hrs = unidad == 15 ? 'creditos' : 'horas';
      await this.$apollo.query({ query: qs }).then(({ data }) => {
        let items = data.getPostgrados.map((item, i = 0) => {
          item.index = ++i;
          item.duracion_text = `${item.duracion} ${parseUnidadDuracion2(item.unidad_duracion)}`;
          item.carga_horaria_text = `${item.carga_horaria} horas`;
          item.creditaje_text = `${item.creditaje} ${hrs}`;
          return item;
        });
        vue.loading = false;
        this.$store.dispatch('postgrado/setPostgrados', items);
        vue.search = vue.nombre;
        if (!this.items.length) {
          this.items = items;
          this.notita = items.length && items[0].unidad_negocio_id == 10;
        }
      }).catch(() => {
        if (!this.items.length)
          this.$root.$notify.show(`No se pudo obtener ${this.menu_name}`, { color: 'primary' });
        vue.loading = false;
      });
    },
    setEstado(est) {
      this.estado = est;
      this.modalExito();
    },
    showEliminar(item) {
      const msg = 'Cambiar Estado';
      const body = `El ${this.menu_name} ${item.categoria.nombre}: ${item.nombre} sera cambiado.`;
      const tag = gql`mutation{ cambiarEstadoPostgrado(input:{id:${item.id},estado:${!item.estado}}){ok,errors{message}} }`;
      this.seleccionado = { xid: item.id, xtitle: msg, xbody: body, xsql: tag };
    },
    modalExitof(id_postgrado, newFase) {
      var pos = this.items.find((x) => x.id == id_postgrado);
      if (pos) pos.status = newFase;
    },
    cambiarPostgradoStatus(post) {
      this.$refs.refAaprobarPostgrado.openmodal(post);
    },
    modalExito() {
      this.cursor = 1000000;
      this.postgrados = [];
      this.nombre = '';
      this.get_postgrados();
    },
    verificarPermiso() {
      this.permiso_add = true;
    },
  },
  mounted() {
    this.verificarPermiso();
    sessionStorage.removeItem('xprogramarest');
    window.localStorage.removeItem('rest_idprograma');
    let cargo = this.$store.state.CARGO.id;
    let userid = this.$store.state.DATA_USER.id;
    let userrobertocca = 32173;
    let usermauren = 3506;
    this.permitido = cargo == 1 || cargo == 17 || userid == 9030 || userid == usermauren || userid == userrobertocca;
    this.isdirectorcca = cargo == 5 || userrobertocca;
    this.load_data();
  },
};
</script>

<style scoped>
.pg-page { min-height: 100vh; background: #f5f7fa; }

.pg-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pg-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.pg-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.pg-body { padding: 20px 24px; }

.pg-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.pg-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.pg-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
} 
.pg-table >>> tbody tr:hover { background: #f0f4ff !important; }
.pg-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
